import React from 'react';
import { CampaignImageType } from 'core/worldCup/raffleImages/types';
import DevicePreviewBanner from './DevicePreviewBanner';
import DevicePreviewMain from './DevicePreviewMain';

type DevicePreviewProps = {
  type: CampaignImageType;
  imageSrc: string | null;
  title: string;
};

const DevicePreview: React.FC<DevicePreviewProps> = ({ type, imageSrc, title }) => {
  switch (type) {
    case CampaignImageType.Banner:
      return <DevicePreviewBanner imageSrc={imageSrc} title={title} />;
    case CampaignImageType.Main:
      return <DevicePreviewMain imageSrc={imageSrc} title={title} />;
    default:
      return null;
  }
};

export default DevicePreview;
